module.exports = __webpack_public_path__ + "static/ad431a4f8e263e1e5ad53847ba7e1b9ae8a0cef4a94307f038a19da6cd51c50b-fd6d76c0f321afd29dc8c065431de09e.png";